import React from 'react'
import { LGPDStyle } from './style'

type LGPDProps = React.FC<{
  validateAcceptedTerms: () => void
  isVerify: boolean
  setIsVerify: React.Dispatch<React.SetStateAction<boolean>>
}>

export const LGPD: LGPDProps = ({ validateAcceptedTerms, isVerify, setIsVerify }) => {
  return (
    <LGPDStyle isVerify={isVerify}>
      <p>Termo de consentimento para armazenamento e tratamento de dados pessoais em conformidade com a LGPD</p>
      <p>
        Este documento visa registrar a manifestação livre, informada e inequívoca pela qual o titular concorda com o
        tratamento de seus dados pessoais para finalidade específica, em conformidade com a Lei nº 13.709 – Lei Geral de
        Proteção de Dados Pessoais (LGPD).
      </p>
      <p>
        Informamos que coletamos seus dados pessoais (Nome, CPF, E-mail e Celular) para fim único e exclusivo de
        pré-cadastro em curso de pós graduação. O pré-cadastro não é uma matrícula nem um compromisso de matrícula, mas
        apenas um interesse em obter maiores informações sobre os cursos de interesse.
      </p>
      {!isVerify ? (
        <button onClick={() => validateAcceptedTerms()}>Li e concordo com os termos</button>
      ) : (
        <button onClick={() => setIsVerify(false)}>Termo aceito</button>
      )}
    </LGPDStyle>
  )
}
